import axios from './axios';

export default class ClaimService {
  static createClaim(loan_public_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/claim/create', { loan_public_id });
  }

  static createLawsuite(loan_public_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/lawsuit/create', { loan_public_id });
  }

  static downloadClaim(public_id) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/claim/download/${public_id}`, {
      responseType: 'blob'
    });
  }

  static downloadLawsuite(lawsuitPublicId) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/lawsuit/download/${lawsuitPublicId}`, {
      responseType: 'blob'
    });
  }

  static signLawsuite(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/lawsuit/sign', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  static signClaim(claim_public_id, otp) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/claim/sign', { claim_public_id, otp });
  }
}
